import React from 'react';
import { Button } from 'antd';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import Input from '../../components/form/Input';
import { required } from '../../components/form/validation';

import s from './style.less';

class ForgotSave extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      error: null,
      loading: false,
    };
  }

  submit = async values => {
    const { history, match } = this.props;
    try {
      this.setState({
        loading: true,
      });

      await fetch('/forgot-password-save', {
        method: 'post',
        body: {
          ...values,
          token: match.params.token,
        },
      });

      history.push('/login');
    } catch (e) {
      this.setState({
        error: e.message || e,
        loading: false,
      });
    }
  };

  render() {
    const { error, loading } = this.state;

    return (
      <div className={s.page}>
        <div className={s.page}>
          <div className={s.page__block}>
            <div className={s.container}>
              <div className={s.page__title}>Choose a password</div>
              <div className={s.row}>
                {error && <div className={s.error}>{error}</div>}
                <div className={s.flex}>
                  <form onSubmit={this.props.handleSubmit(this.submit)}>
                    <div title="Enter your new password below.">
                      <Field
                        type="password"
                        name="password"
                        placeholder="Password"
                        component={Input}
                        validate={required}
                      />
                    </div>
                    <Button
                      className={s.submit}
                      htmlType="submit"
                      type="primary"
                      disabled={loading}
                    >
                      Submit
                    </Button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ForgotSave.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default reduxForm({
  form: 'forgot-info',
})(ForgotSave);
